export default __webpack_public_path__ + "static/media/paren.907fa711.png";